import * as React from "react";
import { Provider, defaultTheme } from "@adobe/react-spectrum";
import { useAppSelector } from "../../store/hooks";

interface SpectrumProviderProps {
  children: React.ReactNode;
}

export const SpectrumProvider: React.FC<SpectrumProviderProps> = ({ children }) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const colorScheme = theme === "dark" ? "dark" : "light";

  return (
    <Provider
      theme={defaultTheme}
      colorScheme={colorScheme}
      locale="en-US"
      UNSAFE_style={{ background: "transparent" }}
    >
      {children}
    </Provider>
  );
};
